<div class="home">
  <div class="hero-image"></div>

  <div class="hero-text">
    <img src="assets/img/everight-logo-small.png" alt="" />
    <h1>
      Welcome To <span>Everight Diagnostic and Laboratory Services </span>
    </h1>
    <p>Accuracy, Innovation and Expertise</p>
    <!-- <a[routerLink]="['/register']">
            <button class="button" mat-raised-button color="primary">Register Patient</button>
        </a> -->
    <button *ngIf="token" mat-raised-button color="primary">
      <a [routerLink]="['/profile']">Dashboard </a>
    </button>
    <button *ngIf="!token" mat-raised-button color="primary">
      <a [routerLink]="['/login']">Login </a>
    </button>
    <div>
      <img
        style="width: 100px; margin-top: 30px"
        src="https://4qrcode.com/URL/qrcodes/19cb8f9c2b755861a79ad017e373013b.svg"
        alt=""
      />
    </div>
  </div>
</div>
